__turbopack_context__.v({
  "Item": "NavbarSecondary-module-scss-module__z0H4pq__Item",
  "List": "NavbarSecondary-module-scss-module__z0H4pq__List",
  "Navbar": "NavbarSecondary-module-scss-module__z0H4pq__Navbar",
});
